import React, { useState } from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useRouteMatch,useHistory } from 'react-router-dom'
import { PatientPersonalHealthRecordsOPtions } from '../../../../Constants/Menus/ConstantMenus'
import { vitalsettings,getpatienthelthdata } from '../../../../../../actions/RPMAction';

function PersonalHealthCare() {

    let [activeTop, setActiveTop] = useState(0)
    let dispatch=useDispatch();
    const location = useLocation();  
    let patientId = localStorage.getItem("patientId");
   // signupData = location.state?.detail;
    console.log(patientId)
    useEffect(() => {
        try {
          // dispatch(getpatienthelthdata(patientId)); 
       }catch (error) {
           console.log("Error in getpatienthelthdata API",error);
       }  
   },[])

  return (
    <div className='patient-medical-container'>

    {/* <div className="patient-medical-container_header">
       <div className='main-header'> Doctor Name: <b>Dr John Dow</b>, Last Consulted on: <b>01, January, 2022</b></div>
    </div> */}

    <div className="patient-medical-container_header">

        <div className="l3-nav patient-dashboard-l3-nav">
            <ul>
                {
                    PatientPersonalHealthRecordsOPtions.map((element, key) => {
                        return (
                            <>
                                <li
                                    key={key}
                                    className={activeTop === key ? "l2-nav-active" : null}
                                    onClick={() => { setActiveTop(key) }}
                                >{element.name}</li>{key < PatientPersonalHealthRecordsOPtions.length - 1 ? " | " : null}
                            </>
                        )
                    })
                }
            </ul>
        </div>



    </div>

    {
        PatientPersonalHealthRecordsOPtions[activeTop]?.component

    }



</div>
  )
}

export default PersonalHealthCare